import { render, staticRenderFns } from "./ProCard.vue?vue&type=template&id=4b7ebfba&scoped=true&"
import script from "./ProCard.vue?vue&type=script&lang=js&"
export * from "./ProCard.vue?vue&type=script&lang=js&"
import style0 from "./ProCard.vue?vue&type=style&index=0&id=4b7ebfba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ebfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7ebfba')) {
      api.createRecord('4b7ebfba', component.options)
    } else {
      api.reload('4b7ebfba', component.options)
    }
    module.hot.accept("./ProCard.vue?vue&type=template&id=4b7ebfba&scoped=true&", function () {
      api.rerender('4b7ebfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ProCard.vue"
export default component.exports